import React from 'react';
import { InView } from 'react-intersection-observer';

import IconDeepResearchText from '@components/Images/DeepResearch/IconDeepResearchText';
import { useAppContext } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { deep_research_path } from '@routes';
import {
  ClickTarget,
  ContentType,
  ImpressionElement,
  TrackingLocation,
  click,
  impression,
} from '@tracking';

import Prompt from './Prompt';

interface EndOfArticleDeepResearchProps {
  id: number;
  prompts: string[];
}

const EndOfArticleDeepResearch = ({ id, prompts }: EndOfArticleDeepResearchProps) => {
  const { isWebview } = useAppContext();
  const { Track, trackEvent } = useEventTracking({
    contentType: ContentType.Article,
    contentId: id,
    location: TrackingLocation.DeepResearchEndArticlePromo,
  });

  const handleLogoClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.DeepResearchLogo }));
  };

  if (!prompts || prompts.length === 0 || isWebview) return null;

  return (
    <Track>
      <InView
        onChange={(inView) => {
          inView &&
            trackEvent(
              impression({ impressionElement: ImpressionElement.DeepResearchEndArticlePromo })
            );
        }}
        triggerOnce
      >
        <aside className="mx-auto mt-48">
          <header className="m-0">
            <h2 className="m-0 flex items-center gap-10 font-suisse-neue text-body-md font-normal text-primary-black">
              Dive deeper with{' '}
              <a href={deep_research_path()} onClickCapture={handleLogoClick}>
                <IconDeepResearchText width={188} height={29} aria-label="Deep Research logo" />
              </a>
            </h2>
          </header>
          <div className="mt-16 flex flex-col gap-y-16">
            {prompts.map((prompt, index) => (
              <Prompt key={`prompt-${id}-${index}`} prompt={prompt} />
            ))}
          </div>
        </aside>
      </InView>
    </Track>
  );
};

export default EndOfArticleDeepResearch;
